import type { ExtraFieldType } from "@package/ui-gql/index-data-access";
import { type FC } from "react";
import { ServiceDataFormFieldArray } from "./ServiceDataFormFields/ServiceDataFormFieldArray";
import { ServiceDataFormFieldBoolean } from "./ServiceDataFormFields/ServiceDataFormFieldBoolean";
import { ServiceDataFormFieldBox } from "./ServiceDataFormFields/ServiceDataFormFieldBox";
import { ServiceDataFormFieldColor } from "./ServiceDataFormFields/ServiceDataFormFieldColor";
import {
  type ServiceDataFormFieldBaseProps,
  ServiceDataFormFieldEmpty,
} from "./ServiceDataFormFields/ServiceDataFormFieldEmpty";
import { ServiceDataFormFieldHelp } from "./ServiceDataFormFields/ServiceDataFormFieldHelp";
import { ServiceDataFormFieldMedia } from "./ServiceDataFormFields/ServiceDataFormFieldMedia";
import { ServiceDataFormFieldNumber } from "./ServiceDataFormFields/ServiceDataFormFieldNumber";
import { ServiceDataFormFieldReference } from "./ServiceDataFormFields/ServiceDataFormFieldReference";
import { ServiceDataFormFieldSelect } from "./ServiceDataFormFields/ServiceDataFormFieldSelect";
import { ServiceDataFormFieldText } from "./ServiceDataFormFields/ServiceDataFormFieldText";
import { ServiceDataFormFieldRichText } from "./ServiceDataFormFields/ServiceDataFormFieldTextArea";
import { ServiceDataFormFieldTextLabel } from "./ServiceDataFormFields/ServiceDataFormFieldTextLabel";

const ExtraFieldTypeNameToComponent: {
  [key in NonNullable<
    ExtraFieldType["__typename"]
  >]: FC<ServiceDataFormFieldBaseProps>;
} = {
  ExtraFieldTypeArray: ServiceDataFormFieldArray,
  ExtraFieldTypeBoolean: ServiceDataFormFieldBoolean,
  ExtraFieldTypeBox: ServiceDataFormFieldBox,
  ExtraFieldTypeColor: ServiceDataFormFieldColor,
  ExtraFieldTypeHelp: ServiceDataFormFieldHelp,
  ExtraFieldTypeMedia: ServiceDataFormFieldMedia,
  ExtraFieldTypeNumber: ServiceDataFormFieldNumber,
  ExtraFieldTypeReference: ServiceDataFormFieldReference,
  ExtraFieldTypeRichText: ServiceDataFormFieldRichText,
  ExtraFieldTypeSearch: ServiceDataFormFieldEmpty,
  ExtraFieldTypeSelect: ServiceDataFormFieldSelect,
  ExtraFieldTypeText: ServiceDataFormFieldText,
  ExtraFieldTypeTextLabel: ServiceDataFormFieldTextLabel,
};

export function ServiceDataFormField({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  const Component =
    field.__typename && ExtraFieldTypeNameToComponent[field.__typename];
  if (Component) {
    return (
      <Component field={field} data={data} onSourceChanged={onSourceChanged} />
    );
  }

  return <div />;
}
